/**
 * @fileoverview Static help content and guided-tour steps for `SystemDashboardsPage`
 * (`/dashboard-templates` in `system-web`).
 * @module system-web/pages/reports/systemDashboardsHelpContent
 *
 * Responsibilities: - Provide `SYSTEM_DASHBOARDS_HELP_SECTIONS` and `SYSTEM_DASHBOARDS_TOUR_STEPS`
 *                     consumed by `GridPageShell` on `SystemDashboardsPage`.
 * Dependencies:     - `@firesquirrel/ui-admin` (GenericHelpSection, TourStep).
 * Architecture:     - Pure static data module; zero I/O.
 * Notes:            - Covers System Library exposure (`isInLibrary`) and visibility modes
 *                     (`All Departments`, `Specific Tenants`, `System Only`).
 */

import type { GenericHelpSection, TourStep } from '@firesquirrel/ui-admin';

export const SYSTEM_DASHBOARDS_HELP_SECTIONS: ReadonlyArray<GenericHelpSection> = [
  {
    id: 'overview',
    title: 'System Dashboard Templates',
    summary: 'Author and curate dashboard templates in the System Library.',
    body: [
      {
        type: 'paragraph',
        text: 'System administrators author dashboard templates here and expose published dashboards in the System Library so fire departments can adopt them.',
      },
      {
        type: 'steps',
        items: [
          'Click "+ New Dashboard Template" to open the 3-pane system dashboard builder.',
          'Once a dashboard is published and has at least one widget, use "Add to Library" to expose it.',
          'Control visibility via "All Departments", "Specific Tenants", or "System Only".',
        ],
      },
    ],
  },
];

export const SYSTEM_DASHBOARDS_TOUR_STEPS: TourStep[] = [
  {
    targetSelector: '',
    title: 'System Dashboard Templates',
    body: 'Manage system-wide dashboard templates and their System Library visibility from this grid.',
    placement: 'center',
  },
  {
    targetSelector: 'input[placeholder^="Search"]',
    title: 'Search Templates',
    body: 'Filter system dashboard templates by name or status.',
    placement: 'bottom',
  },
];
